import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RootRoutes } from './root-routes';
import { LoginComponent } from './login/components/login/login.component';
import { SearchComponent } from './search/components/search/search.component';
import { DirectLinkLoginComponent } from '@root/login/components/direct-link-login/direct-link-login.component';
import { AuthGuard } from '@shared/guards/auth.guard';
import { EulaGuard } from '@shared/guards/eula.guard';
import { DirectLinkDataResolverService } from '@shared/services/direct-link-data-resolver.service';
import { RefreshComponent } from '@shared/components/refresh/refresh.component';
import { PropertyIntelligenceResolver } from './property-intelligence/resolvers/property-intelligence.resolver';
import { CallbackRedirectComponent } from './callback-redirect.component';

const routes: Routes = [
  {
    path: RootRoutes.DirectLinkLogin,
    component: DirectLinkLoginComponent
  },
  {
    path: RootRoutes.MobileLogin,
    redirectTo: RootRoutes.Login
  },
  {
    path: RootRoutes.Login,
    component: LoginComponent,
    data: {
      showSearch: true
    }
  },
  {
    path: RootRoutes.Logout,
    loadChildren: () => import('@root/logout/logout.module').then((m) => m.LogoutModule)
  },
  {
    path: RootRoutes.Refresh,
    component: RefreshComponent
  },
  {
    path: RootRoutes.Dashboard,
    canActivate: [AuthGuard, EulaGuard],
    loadChildren: () => import('@root/dashboard/dashboard.module').then((m) => m.DashboardModule),
    runGuardsAndResolvers: 'always'
  },
  {
    path: RootRoutes.PropertyIntelligence,
    canActivate: [AuthGuard, EulaGuard],
    loadChildren: () => import('@root/property-intelligence/property-intelligence.module').then((m) => m.PropertyIntelligenceModule),
    resolve: {
      isGeoDataAvailable: PropertyIntelligenceResolver,
    },
    runGuardsAndResolvers: 'always'
  },
  {
    path: RootRoutes.Search,
    component: SearchComponent,
    canActivate: [AuthGuard, EulaGuard],
    resolve: {
      directLinkLoading: DirectLinkDataResolverService
    },
    runGuardsAndResolvers: 'always'
  },
  {
    path: RootRoutes.SavedProperties,
    canActivate: [AuthGuard, EulaGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('@root/saved-properties/saved-properties.module').then((m) => m.SavedPropertiesModule)
  },
  {
    path: RootRoutes.Reports,
    canActivate: [AuthGuard, EulaGuard],
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('@root/reports/reports.module').then((m) => m.ReportsModule)
  },
  {
    path: RootRoutes.Settings,
    canActivate: [AuthGuard],
    loadChildren: () => import('@root/settings/settings.module').then((m) => m.SettingsModule)
  },
  {
    path: RootRoutes.Orders,
    canActivate: [AuthGuard],
    loadChildren: () => import('@root/orders/orders.module').then((m) => m.OrdersModule)
  },
  {
      path: RootRoutes.OrdersHistory,
      canActivate: [AuthGuard],
      loadChildren: () => import('@root/orders/orders.module').then((m) => m.OrdersModule)
  },
  {
      path: RootRoutes.OrdersDetails,
      canActivate: [AuthGuard],
      loadChildren: () => import('@root/orders/orders.module').then((m) => m.OrdersModule)
  },
  {
      path: RootRoutes.OrderReturn,
      canActivate: [AuthGuard],
      loadChildren: () => import('@root/orders/orders.module').then((m) => m.OrdersModule)
  },
  {
    path: RootRoutes.Help,
    canActivate: [AuthGuard],
    loadChildren: () => import('@root/help/help.module').then((m) => m.HelpModule)
  },
  {
    path: RootRoutes.Redirect,
    canActivate: [AuthGuard],
    component: CallbackRedirectComponent
  },
  {
    path: RootRoutes.Redirect + '/:reportCode/:fipsCode/:apn',
    canActivate: [AuthGuard],
    component: CallbackRedirectComponent
  },
  { path: '**', pathMatch: 'full', redirectTo: RootRoutes.Login }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
